import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Eyes_10 = ({ eyeColours, skinColours }) => {
  const colour0 = skinColours.shadow;
  const colour1 = '#573D39';
  return (
    <>
      <g>
        <path
          fill={colour0}
          d="M483.1,415.8c-37.7-5.4-66.8-17.4-63.6-21c3.1-3.6,10.5-20.7,25.4-26.3c32.2-12.1,56.4,29.2,56.4,29.2
		c-22.9,9.3-58-15-74.9-2.1C427.2,397.1,483.1,415.8,483.1,415.8z"
        />
        <path
          fill={colour1}
          d="M450.6,387.2c-12-2.3-24.3,1.2-31.3,8.9l9.8,0.7c8-6.5,23.6-2.4,43.3,2.4c19.7,4.9,28.8-1.6,28.8-1.6
		C482.4,402.7,462.7,389.4,450.6,387.2z"
        />
        <path
          fill={colour1}
          d="M491.4,388.1c0,0-8.5,7.8-15.7,7.9l3.5,1.4C479.2,397.5,488.9,395.6,491.4,388.1z"
        />
        <path
          fill={colour1}
          d="M481.8,384.5c0,0-3.8,9.4-9.8,10.8l3.6,0.8C475.6,396.1,483.1,392.4,481.8,384.5z"
        />
        <path
          fill={colour1}
          d="M474.2,382.8c0,0-1.7,9.5-6.8,11.4l3.3,0.6C470.8,394.7,476.9,390.5,474.2,382.8z"
        />
        <path
          fill={colour1}
          d="M465.6,381.9c0,0,0.5,9.3-3.6,11.5l3,0.4C465.1,393.8,469.4,389.2,465.6,381.9z"
        />
        <path
          fill={colour0}
          d="M313.5,415.8c37.7-5.4,66.8-17.4,63.6-21c-3.1-3.6-10.5-20.7-25.4-26.3c-32.2-12.1-56.4,29.2-56.4,29.2
		c22.9,9.3,58-15,74.9-2.1C369.3,397.1,313.5,415.8,313.5,415.8z"
        />
        <path
          fill={colour1}
          d="M345.9,387.2c12-2.3,24.3,1.2,31.3,8.9l-9.8,0.7c-8-6.5-23.6-2.4-43.3,2.4c-19.7,4.9-28.8-1.6-28.8-1.6
		C314.2,402.7,333.9,389.4,345.9,387.2z"
        />
        <path
          fill={colour1}
          d="M305.2,388.1c0,0,8.5,7.8,15.7,7.9l-3.5,1.4C317.3,397.5,307.6,395.6,305.2,388.1z"
        />
        <path
          fill={colour1}
          d="M314.7,384.5c0,0,3.8,9.4,9.8,10.8l-3.6,0.8C321,396.1,313.5,392.4,314.7,384.5z"
        />
        <path
          fill={colour1}
          d="M322.4,382.8c0,0,1.7,9.5,6.8,11.4l-3.3,0.6C325.8,394.7,319.7,390.5,322.4,382.8z"
        />
        <path
          fill={colour1}
          d="M331,381.9c0,0-0.5,9.3,3.6,11.5l-3,0.4C331.5,393.8,327.1,389.2,331,381.9z"
        />
      </g>
    </>
  );
};

export default Eyes_10;
